<script>
import moment from 'moment';
import VueApexCharts from 'vue3-apexcharts';
import { getCardStats } from '@/utils/business-card';

export default {
  components: { apexchart: VueApexCharts },
  data() {
    return {
      loading: false,
      card_name: '',
      total_views: 0,
      days: [],
    };
  },

  computed: {
    total_qr_scans() {
      return this.days.reduce((sum, d) => sum + d.qr_scans, 0);
    },
    series() {
      return [
        { name: 'Views', data: this.days.map(d => d.views) },
        { name: 'QR scans', data: this.days.map(d => d.qr_scans) },
      ];
    },
    options() {
      return {
        chart: { toolbar: { show: false }, zoom: { enabled: false } },
        stroke: { curve: 'smooth', width: 2 },
        dataLabels: { enabled: false },
        colors: ['#6366f1', '#22c55e'],
        xaxis: {
          categories: this.days.map(d => moment(d.date).format('DD MMM')),
          tickAmount: 8,
          labels: { rotate: 0 },
        },
        yaxis: { min: 0, forceNiceScale: true, labels: { formatter: v => Math.round(v) } },
        legend: { position: 'top' },
      };
    },
  },

  methods: {
    async open(row) {
      this.card_name = row.user?.name || '';
      this.total_views = 0;
      this.days = [];
      this.loading = true;
      try {
        const response = await getCardStats(row.id);
        const data = response.data.data || {};
        this.total_views = data.total_views || 0;

        // The API returns only days that have data, so fill all 30 days with zeros
        const map = {};
        (data.last_30_days || []).forEach(d => {
          map[d.date] = { views: Number(d.views) || 0, qr_scans: Number(d.qr_scans) || 0 };
        });
        const days = [];
        for (let i = 29; i >= 0; i--) {
          const date = moment().subtract(i, 'days').format('YYYY-MM-DD');
          days.push({ date, views: map[date]?.views || 0, qr_scans: map[date]?.qr_scans || 0 });
        }
        this.days = days;
      } catch (error) {
        this.$swalToast(error.message, 'error');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.s-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 16px;
}
.s-num { font-size: 22px; font-weight: 700; color: #0f172a; }
.s-label { font-size: 11px; color: #64748b; text-transform: uppercase; letter-spacing: .3px; }
</style>

<template>
  <div class="modal fade" id="stats_modal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Card Stats<span v-if="card_name"> - {{ card_name }}</span></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body">
          <div v-if="loading" class="text-center py-5">Loading...</div>

          <template v-else>
            <div class="row g-3 mb-3">
              <div class="col-6">
                <div class="s-box">
                  <div class="s-num">{{ total_views }}</div>
                  <div class="s-label">Total views</div>
                </div>
              </div>
              <div class="col-6">
                <div class="s-box">
                  <div class="s-num">{{ total_qr_scans }}</div>
                  <div class="s-label">QR scans (last 30 days)</div>
                </div>
              </div>
            </div>

            <apexchart v-if="days.length" type="line" height="280" :options="options" :series="series" />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>